<template>
  <v-footer
    id="page-footer"
    :absolute="true"
    color="secondary"
    height="auto"
  >
    <links />
  </v-footer>
</template>

<script>
// Components
import Links from '@/components/Links';

export default {
  name: 'PageFooter',

  components: { Links },
};
</script>
